import { useRef, useCallback, useState, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import styles from './SignatureCapture.module.scss';

interface SignatureCaptureProps {
  onSave: (dataUrl: string) => void;
  onCancel: () => void;
}

export function SignatureCapture({ onSave, onCancel }: SignatureCaptureProps) {
  const sigRef = useRef<SignatureCanvas>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [canvasWidth, setCanvasWidth] = useState(500);
  const canvasHeight = Math.round(canvasWidth * 0.4);

  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return;
    const update = () => setCanvasWidth(Math.min(500, el.clientWidth));
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const handleClear = useCallback(() => { sigRef.current?.clear(); }, []);

  const handleSave = useCallback(() => {
    if (sigRef.current?.isEmpty()) return;
    const dataUrl = sigRef.current?.toDataURL('image/png') ?? '';
    onSave(dataUrl);
  }, [onSave]);

  return (
    <div className={styles.capture}>
      <div className={styles.canvasWrapper} ref={wrapperRef}>
        <SignatureCanvas
          ref={sigRef}
          canvasProps={{ className: styles.canvas, width: canvasWidth, height: canvasHeight }}
          penColor="#000"
        />
      </div>
      <p className={styles.hint}>Draw your signature above</p>
      <div className={styles.actions}>
        <button className={styles.btnGhost} onClick={handleClear}>Clear</button>
        <div className={styles.actionRight}>
          <button className={styles.btnSecondary} onClick={onCancel}>Cancel</button>
          <button className={styles.btnPrimary} onClick={handleSave}>Apply Signature</button>
        </div>
      </div>
    </div>
  );
}
